const crypto = require('crypto');
const algorithm = 'aes-256-cbc';
const iv = Buffer.from('4mysayuniquesite');
const parsePhoneNumber = require('libphonenumber-js');

const round = (num, decimalPlaces = 2) => {
    var p = Math.pow(10, decimalPlaces);
    return Math.round(num * p) / p;
}

const truncate = (str, n = 12) => {
    return (str?.length > n) ? str.substr(0, n - 1) + '...' : str;
};

const encrypt = (str) => {
    let secret = process.env.ENCRYPTION_SECRET;
    let cipher = crypto.createCipheriv(algorithm, Buffer.from(secret), iv);
    let encrypted = cipher.update(str);
    encrypted = Buffer.concat([encrypted, cipher.final()]);
    return encrypted.toString('hex');
}

const decrypt = (str) => {
    let secret = process.env.ENCRYPTION_SECRET;
    let encryptedText = Buffer.from(str, 'hex');
    let decipher = crypto.createDecipheriv(algorithm, Buffer.from(secret), iv);
    let decrypted = decipher.update(encryptedText);
    decrypted = Buffer.concat([decrypted, decipher.final()]);
    return decrypted.toString();
}

const states = ["ACT", "WA", "SA", "NT", "QLD", "NSW", "VIC", "TAS"].sort();

const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
}

const getValueAtPath = (obj, path) => {
    if (!obj || !path) return undefined;
    return path.split('.').reduce((o, i) => (o ? o[i] : undefined), obj);
}

const numberFormat = (number, decimalPlaces = 2, decimalSeparator = ".", thousandsSeparator = ",", prefix = "") => {
    decimalPlaces = isNaN(decimalPlaces = Math.abs(decimalPlaces)) ? 2 : decimalPlaces;
    decimalSeparator = decimalSeparator == undefined ? "." : decimalSeparator;
    thousandsSeparator = thousandsSeparator == undefined ? "," : thousandsSeparator;
    prefix = prefix == undefined ? '' : prefix;
    const s = number < 0 ? "-" : "";
    var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decimalPlaces)));
    var j = (j = i.length) > 3 ? j % 3 : 0;
    return s + prefix + (j ? i.substr(0, j) + thousandsSeparator : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousandsSeparator) + (decimalPlaces ? decimalSeparator + Math.abs(number - i).toFixed(decimalPlaces).slice(2) : "");
}

const formatPhoneNumber = (phoneNumber) => {
    const parsed = parsePhoneNumber(phoneNumber);
    if (parsed) {
        return parsed.formatInternational();
    }
    return phoneNumber;
}

const formatMoney = (amount) => {
    return numberFormat(amount, 2, '.', ',', '$');
}

const cleanQueryParams = (query) => {
    const cleanedQuery = {};

    for (const key in query) {
        const value = query[key];
        if (typeof value === 'string') {
            cleanedQuery[key] = value.trim();
        } else {
            cleanedQuery[key] = value;
        }
    }

    return cleanedQuery;
}

// Cooldown flag preventing the poll index page from auto-redirecting to
// demographics repeatedly (defence-in-depth against the demographics <-> index
// infinite redirect loop). Scoped to sessionStorage (per-tab) and cleared once
// the demographics page loads successfully.
const POLL_DEMOGRAPHICS_REDIRECT_FLAG = 'poll_flow_redirected_to_demographics';

const getPollDemographicsRedirectFlag = () => {
    try {
        return typeof window !== 'undefined' && sessionStorage.getItem(POLL_DEMOGRAPHICS_REDIRECT_FLAG) === '1';
    } catch (e) {
        return false;
    }
};

const setPollDemographicsRedirectFlag = () => {
    try {
        if (typeof window !== 'undefined') sessionStorage.setItem(POLL_DEMOGRAPHICS_REDIRECT_FLAG, '1');
    } catch (e) {
        // ignore storage failures (e.g. blocked storage in in-app browsers)
    }
};

const clearPollDemographicsRedirectFlag = () => {
    try {
        if (typeof window !== 'undefined') sessionStorage.removeItem(POLL_DEMOGRAPHICS_REDIRECT_FLAG);
    } catch (e) {
        // ignore storage failures
    }
};

module.exports = {
    round,
    truncate,
    encrypt,
    decrypt,
    sleep,
    states,
    numberFormat,
    formatPhoneNumber,
    getValueAtPath,
    cleanQueryParams,
    formatMoney,
    getPollDemographicsRedirectFlag,
    setPollDemographicsRedirectFlag,
    clearPollDemographicsRedirectFlag
}